// src/lib/offline-queue.ts
// H1: Buchungs-Aktionen ueberleben Funkloecher. Jede Aktion traegt einen
// client-erzeugten idempotency_key — der Server dedupliziert beim Nachsenden.
export interface QueuedAction {
  id: string
  path: string
  body: Record<string, unknown>
  queuedAt: string
}

export function newIdempotencyKey(): string {
  return (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`)
}

export class OfflineQueue {
  private key: string
  constructor(name: string) { this.key = `stahlia_whq_${name}` }

  pending(): QueuedAction[] {
    try { return JSON.parse(localStorage.getItem(this.key) ?? '[]') as QueuedAction[] }
    catch { return [] }
  }
  private save(items: QueuedAction[]): void {
    localStorage.setItem(this.key, JSON.stringify(items))
  }
  enqueue(a: { path: string; body: Record<string, unknown> }): QueuedAction {
    const item: QueuedAction = {
      id: newIdempotencyKey(), path: a.path, body: a.body, queuedAt: new Date().toISOString(),
    }
    this.save([...this.pending(), item])
    return item
  }
  /** sender: true = erledigt (Item wird entfernt); false/throw = bleibt UND bricht den
   *  Flush ab. FIFO-Abbruch, weil Queue-Items fachlich abhaengig sein koennen (erst
   *  /pickup, dann /place derselben Palette): wuerde ein spaeteres Item am haengenden
   *  Vorgaenger vorbei versucht, lehnt das Backend es final ab (blocked) und die
   *  Buchung ginge verloren, obwohl der Vorgaenger spaeter noch landet.
   *  Spiegel-Hinweis: gleiche Semantik wie stahlia-scan-app/src/logic/queue.ts. */
  async flush(sender: (item: QueuedAction) => Promise<boolean>): Promise<{ sent: number; failed: number }> {
    const items = this.pending()
    const removedIds = new Set<string>()
    let sent = 0
    for (const item of items) {
      let ok = false
      try { ok = await sender(item) } catch { ok = false }
      if (!ok) break
      sent++; removedIds.add(item.id)
    }
    // Kein Snapshot-Overwrite: waehrend der awaits kann enqueue() neue Items geschrieben
    // haben — Re-Read und nur die tatsaechlich gesendeten entfernen, sonst gehen sie verloren.
    this.save(this.pending().filter((i) => !removedIds.has(i.id)))
    return { sent, failed: items.length - sent }
  }
}
